
$(".js-addenfant").click(function(e){
    var target = $(this).data("target");
    var clone = $(this).data("clone");
    var nbr = $("#" + target).find(".js-rowenfant").length;
    var elt = $("#" + clone).children().clone();

    //On incrémente les id et les names de 1
    elt.html(elt.html().replace(/{id}/gi, nbr + 1));

    elt.appendTo("#" + target);
});

$("body").on("click",".js-delenfant",function(e){
    $(this).closest(".js-rowenfant").remove();
});

$("input[name='type']").change(function(e){
    if( $(this).val() == 'famille' ){
        $("#js-enfants").removeAttr("hidden");
    }else{
        $("#js-enfants").attr("hidden","");
    }
});

$(".js-chambre").change(function(e){
    var cost = $(this).find("option:selected").data("cost");
    var parent = $(this).closest("tr");
    parent.find(".js-pu").val( cost );
    parent.find(".js-spanpu").html( cost + " €");
    parent.find(".js-soustotal").val( cost * parent.find(".js-qte").val() );
    parent.find(".js-spanpu").html( new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(cost) );
    calculTotal();
});


$("#estimation").submit(function(e){
    $(this).find(".js-estimation-wait").removeAttr("hidden");
    $(this).find("[type='submit']").hide();
});


$("#js-prestation").on('keyup','.js-qte',function(e){
    var row = $(this).closest("tr");
    var prix = row.find(".js-pu").val();
    prix = prix.replace(/,/gi,'.');
    var value =  prix * parseFloat($(this).val());
    if( isNaN(value) ) {
        row.find(".js-soustotal").val('');
    }else{
        row.find(".js-soustotal").val(value);
    }
    calculTotal();
});

function calculTotal() {
    var total = 0;
    $(".js-soustotal").each(function(index){
        var val = parseFloat($(this).val());
        if( !isNaN(val) ) {
            total += parseFloat($(this).val());
        }
    });
    $(".js-total").val(total + " euros");
}